const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assessments Manager Directive to display a list or table with tracks to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assessmentsManager', ['Application', 'Authorization', 'Assessments', 'AdminContent', 'Tracks', 'AccessHelper', '$q', '$translate', function(Application, Authorization, Assessments, AdminContent, Tracks, AccessHelper, $q, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        tabName: '=',
        refresh: '=?'
      },
      template: require('../../../templates/directives/assessments/assessments-manager.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.directory = {};
          self.showArchiveConfirmation = false;
          self.assessments = [];
          self.per_page = 20;
          self.selection = [];
          self.assessmentsRemoved = 0;
          self.loading = false;
          self.clearFilter = false;
          self.translations = {};

          self.access = {
            assignments: AccessHelper.isAllowed(['admin', 'assignments', 'create'], null, ['admin', 'creator']),
            archive: AccessHelper.isAllowed(['admin', 'content', 'archive_content'], null, ['admin']),
            duplicate: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'assessments_create']], ['admin', 'creator', 'collaborator']),
            edit: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'assessments_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator'])
          };

          self.assignmentsV2 = Application.features.useAssignmentsV2();

          self.assignment = {
            selection: [],
            show: false,
            select: function() {
              self.assignment.selection.splice(0);
              for (var i = 0; i < self.selection.length; i++) {
                self.assignment.selection.push(self.directory[self.selection[i]]);
              }

              if (self.assignmentsV2) {
                // The React assignment builder reads this handoff back keyed on each
                // item's `type`; force 'assessment' so it resolves the right content type.
                var handoff = self.assignment.selection.map(function(item) {
                  return angular.extend({}, item, { type: 'assessment' });
                });
                Application.storage.put('learn-app-assignment-content-selection', handoff);
                window.location.replace('/admin/assignments/create');
                return;
              }

              self.assignment.show = true;
            }
          };
          self.isCollaborator = function() {
            return Authorization.isCollaborator();
          };
          self.getStandardQuery = function() {
            var q = {
              types: 'assessments',
              fields: 'user,title,type,createdAt,video_assessment,file_assessment,archived,content,privacy_collaborators',
              archived: '$ne,true',
              page: 1,
              per_page: self.per_page,
              'user-populate': 'first_name,last_name,full_name,email',
              sort: 'createdAt,-1'
            };
            if (self.isCollaborator()) {
              q.privacy_collaborators = '$in,1,' + Authorization.getAuthToken().user._id;
            }
            return q;
          };
          self.query = self.getStandardQuery();

          self.initialize = function() {
            self.initialized = true;
            self.load();
          };

          self.load = function() {
            self.loading = true;
            self.contentLoading = true;

            AdminContent.findAnalytics(self.query).$promise
            .then(function(results) {
              self.assessments.length = 0;
              self.assessmentsRemoved = 0;
              self.assessments = results.data;
              self.loading = false;
              self.contentLoading = false;
            }).catch(function(error) {
              self.loading = false;
              self.contentLoading = false;
              console.log('Error getting assessments:', error);
            });
          };
          self.previous = function() {
            if (self.query.page === 1) {
              return;
            }
            self.query.page--;
            self.load();
          };
          self.next = function() {
            if (self.assessments.length !== self.per_page && !self.assessmentsRemoved) {
              return;
            }
            self.query.page++;
            self.load();
          };

          self.searchItems = {
            placeholder: self.translations['assessmentsManager.search_assessments'],
            onQuery: function(opts) {
              self.query = self.getStandardQuery();
              self.query.page = 1;
              self.searching = false;
              if (opts && typeof opts === 'object' && Object.keys(opts).length) {
                self.searching = true;
              }
              if (!opts) {
                self.load();
                return;
              }

              for (var key in opts) {
                self.query[key] = opts[key];
              }
              self.load();
            }
          };
          self.select = function(item) {
            var id = item._id;
            var index = self.selection.indexOf(id);
            if (index === -1) {
              self.directory[id] = item;
              self.directory[id].type = self.directory[id].type ? self.directory[id].type : 'assessment';
              self.selection.push(id);
              return;
            }
            self.selection.splice(index, 1);
            delete self.directory[id];
          };
          self.removeSelections = function() {
            for (var i = self.selection.length - 1; i >= 0; i--) {
              self.select(self.directory[self.selection[i]]);
            }
            self.selection.splice(0);
          };
          self.goToAddAssessments = function() {
            if (!self.access.duplicate) {
              return;
            }
            Application.navigation.goTo('edit/assessments/new');
          };
          self.goToLink = function(assessment) {
            if (!assessment.content || !assessment.content.content_id) {
              return;
            }
            var type = assessment.content.content_name || assessment.content.content_type;
            if (!type) {
              return;
            }
            type = type.toLowerCase();
            if (type !== 'track') {
              type += 's';
            }
            return ('#/host/' + type + '/' + assessment.content.content_id);
          }
          self.editAssessment = function(assessment) {
            if (!self.access.edit) {
              return;
            }
            Application.navigation.goTo('edit/assessments/' + assessment._id);
          };
          self.confirmArchive = function() {
            self.showArchiveConfirmation = true;
          };
          self.cancelArchive = function() {
            self.showArchiveConfirmation = false;
          };
          self.archive = function() {
            if (self.selection.length === 0 || self.assessments.length === 0) {
              return;
            }

            var findContent = [];
            var findContentPromises = [];
            var promises = [];
            self.selection.forEach(function(item) {
              if (self.directory[item].content && self.directory[item].content.content_type === 'Track') {
                findContent.push(item);
                findContentPromises.push(Tracks.find({fields: 'name,sections,archived', 'sections.courses.assessment': self.directory[item]._id, archived: '$ne,true'}).$promise);
                return;
              }
            });

            self.loading = true;
            $q.all(findContentPromises)
                .then(function(results) {
                  self.deleteFromContent = [];
                  findContent.forEach(function(id, index) {
                    if (results[index] && results[index].length) {
                      self.deleteFromContent.push(self.directory[id]);
                    }
                  });

                  if (self.deleteFromContent.length) {
                    self.showArchiveContentError = true;
                    return 'error';
                  }

                  self.selection.forEach(function(item) {
                    promises.push(Assessments.update({
                      subresource: item,
                      fields: 'archived'
                    }, {archived: true}).$promise);
                  });

                  return $q.all(promises);
                }).then(function(results) {
              if (results === 'error') {
                self.showArchiveConfirmation = false;
                self.loading = false;
                return;
              }
              self.removeSelections();
              self.assessments = [];
              self.query = self.getStandardQuery()
              self.clearFilter = true;
              $scope.refresh = 'archived';
              self.load();
              self.showArchiveConfirmation = false;
              Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['assessmentsManager.archive_successful']});
              self.loading = false;
            }).catch(function(error) {
              self.loading = false;
              console.log('error: ', error);
            });
          };

          self.duplicates = {
            loading: false,
            show: false,
            selected: null,
            confirm: function() {
              self.duplicates.selected = null;
              if (self.selection && self.selection.length === 1 && self.directory[self.selection[0]]) {
                self.duplicates.selected = self.directory[self.selection[0]];
                self.duplicates.show = true;
              }
            },
            duplicateItem: function() {
              self.duplicates.loading = true;
              Assessments.duplicate({subresource: self.duplicates.selected._id}, {}).$promise
                  .then(function(results) {
                    delete self.directory[self.duplicates.selected._id];
                    self.selection = [];
                    self.duplicates.selected = null;
                    self.duplicates.show = false;
                    self.duplicates.loading = false;
                    self.load();
                  }).catch(function(error) {
                console.log('error: ', error);
                self.duplicates.loading = false;
              })
            }
          };

          $scope.$watch('refresh', function(newVal, oldVal) {
            if (!self.initialized || !newVal || newVal === oldVal) {
              return;
            }
            self.removeSelections();
            self.assessments = [];
            self.query = self.getStandardQuery();
            self.initialize();
            $scope.refresh = null;
          });

          $translate([
            'assessmentsManager.search_assessments',
            'assessmentsManager.archive_successful'
          ]).then(function(translations) {
            self.translations = translations;
            self.initialize();
          });

        }],
      controllerAs: 'assessmentsManager'
    };
  }]);
